module.exports = __webpack_public_path__ + "static/media/allGenerationsOff.bececd2f.jpg";